import { render, staticRenderFns } from "./ParkingItem.vue?vue&type=template&id=2bc7ab99"
import script from "./ParkingItem.vue?vue&type=script&lang=js"
export * from "./ParkingItem.vue?vue&type=script&lang=js"
import style0 from "./ParkingItem.vue?vue&type=style&index=0&id=2bc7ab99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports